import { render, staticRenderFns } from "./RegisterWholesale.vue?vue&type=template&id=219fcd84&scoped=true&"
import script from "./RegisterWholesale.vue?vue&type=script&lang=ts&"
export * from "./RegisterWholesale.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterWholesale.vue?vue&type=style&index=0&id=219fcd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219fcd84",
  null
  
)

export default component.exports